import type { ComponentPropsWithRef } from "react";

import { cn } from "@/services/styles/cn";

export interface SectionProps extends ComponentPropsWithRef<"section"> {
  classes?: {
    section?: string;
    container?: string;
  };
}

export function Section({ children, className, classes, ...props }: SectionProps) {
  return (
    <section
      className={cn(
        "flex w-full justify-center bg-primary-foreground px-4 md:px-16 xl:px-0",
        classes?.section,
        className,
      )}
      {...props}
    >
      <div className={cn("flex w-full max-w-[1216px] flex-col", classes?.container)}>{children}</div>
    </section>
  );
}
